import { faCircle } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcText } from "components";

export const MprcCallout = () => {
    return (
        <MprcText color="warning">
            <FontAwesomeIcon icon={faCircle} size="xs" />
        </MprcText>
    );
};
